import { EntitiesTypes } from '@email-editor/ui'
import { useRollbar } from '@rollbar/react'
import { NeutralButton } from '@systemeio/ui'
import { useState } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import * as api from '../../../api/emailApi'
import { useExitUrlContext } from '../../../context/ExitUrlContext'
import { useIsTemplateContext } from '../../../context/isTemplateContext'
import { BadRequest } from '../../../errors/BadRequest'
import { InternalError } from '../../../errors/InternalError'
import { NotFound } from '../../../errors/NotFound'
import { useUnsavedData } from '../../../hooks/use-unsaved-data'
import { emailSelectors, useEmail } from '../../../store'
import * as emailActions from '../../../store/email/actions'
import ModalConfirmation from '../Modal/ModalConfirmation'

function ExitButton() {
  const { t } = useTranslation()
  const exitUrl = useExitUrlContext()
  const [isDialogOpen, openDialog] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const isTemplate = useIsTemplateContext()
  const isEmailModified = useEmail(emailSelectors.isEmailModified)
  const settings = useEmail(emailSelectors.getSettings)
  const entities = useEmail(emailSelectors.getEntities)
  const files = useEmail(emailSelectors.getFiles)
  const id = useEmail(emailSelectors.getId)
  const handleError = useErrorHandler()
  const dispatch = useDispatch()

  const rollbar = useRollbar()

  const { deleteDbRecord } = useUnsavedData({ notExecute: true })

  async function handleSave() {
    try {
      if (!id) return
      setIsLoading(true)
      await api.save(
        {
          id,
          content: { settings, entities },
          files,
        },
        isTemplate,
      )
      await deleteDbRecord()
      dispatch(emailActions.updateHash(entities as EntitiesTypes[]))
      setIsLoading(false)
    } catch (error) {
      if (error instanceof InternalError) {
        rollbar.error('Internal server error')
        handleError(error)
      } else if (error instanceof NotFound) {
        alert('Page not found')
        window.location.assign(window.location.origin)
        // handleError(error)
      } else if (error instanceof BadRequest) {
        console.log(error.messages)
      }
    }
  }

  const handleExit = () => {
    window.location.assign(exitUrl)
  }

  const checkAndExit = () => {
    if (isEmailModified) {
      openDialog(true)
    } else {
      window.location.assign(exitUrl)
    }
  }

  const saveAndExit = async () => {
    await handleSave()
    closeDialog()
    handleExit()
  }

  const closeDialog = () => openDialog(false)

  return (
    <>
      <ModalConfirmation
        handleSave={saveAndExit}
        handleClose={closeDialog}
        handleExit={handleExit}
        isLoading={isLoading}
        isOpen={isDialogOpen}
        confirmationText={t('core.header.exit_confirmation_title')}
      />

      <NeutralButton title={t('core.header.exit')} onClick={checkAndExit}>
        {t('core.header.exit')}
      </NeutralButton>
    </>
  )
}

export default ExitButton
